(function ($) {
    "use strict";

    $(function () {

        $('.js-done-select').SumoSelect({
            forceCustomRendering: true,
            floatWidth: 0,
            placeholder: done_awesome_filter_localize.selectPlaceholder,
            captionFormat: done_awesome_filter_localize.captionFormat,
            captionFormatAllSelected: done_awesome_filter_localize.captionFormatAllSelected,
            noMatch: done_awesome_filter_localize.noMatch,
        });

        $('.js-done-select-search').SumoSelect({
            forceCustomRendering: true,
            floatWidth: 0,
            search: true,
            searchText: done_awesome_filter_localize.searchText,
            placeholder: done_awesome_filter_localize.selectPlaceholder,
            captionFormat: done_awesome_filter_localize.captionFormat,
            captionFormatAllSelected: done_awesome_filter_localize.captionFormatAllSelected,
            noMatch: done_awesome_filter_localize.noMatch,
        });

        $('.done__collapse .done__control_label').on('click', function () {
            $(this).siblings('.done__control_group').slideToggle();
            $(this).siblings('.done__minus_icon').toggleClass('open');
            $(this).siblings('.done__plus_icon').toggleClass('close');
        });


        if ($('.js-done-range-slider').length) {

            var $sliders = $('.js-done-range-slider');

            $.each($sliders, function (i, el) {
                var $current_slider_parent = $(el).parent();

                /* Shared settins for range sliders */
                noUiSlider.create($($sliders)[i], {
                    start: [parseInt($(el).data('start-min')), parseInt($(el).data('start-max'))],
                    connect: true,
                    range: {
                        'min': parseInt($(el).data('min')),
                        'max': parseInt($(el).data('max'))
                    },
                    step: 5.0,
                    format: wNumb({
                        decimals: 0,
                    })

                });

                /* Update value fields on change of handles */
                $($sliders)[i].noUiSlider.on('update', function (values, handle) {

                    var value = values[handle];


                    if (handle) {
                        $current_slider_parent.find($('.js-done-range-max')).val(value);
                    } else {
                        $current_slider_parent.find($('.js-done-range-min')).val(value);
                    }
                });

                $($sliders)[i].noUiSlider.on('change', function (values, handle) {

                    $current_slider_parent.addClass('slider-active');


                });
            });


            /* Update values width input fields if not readonly */
            $('.js-done-range-min').on('change', function () {
                $(this).parent().find($('.js-done-range-slider'))[0].noUiSlider.set([this.value, null]);
            });

            $('.js-done-range-max').on('change', function () {
                $(this).parent().find($('.js-done-range-slider'))[0].noUiSlider.set([null, this.value]);
            });


        }



    });

})(jQuery);